import { Button, Stack, Typography, styled } from '@mui/material';

export const ComponentRescateCont = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
});
export const ContentAvatarRescue = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px',
  width: '100%',
  gap: '8px',
}));

export const RescueAvatarIcon = styled(Stack)({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px',
});

export const RescueAvatarDescript = styled(Stack)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  [theme.breakpoints.between('sm', 'md')]: {
    gap: '4px',
  },
}));

export const RescueIconsPorfolio = styled(Stack)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  left: '0px',
  top: '0px',
  height: '80px',
  width: '80px',
  [theme.breakpoints.down('md')]: {
    width: '66px',
    height: '66px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '46px',
    height: '46px',
  },
}));
export const IconosPerfiles = styled('img')({
  height: 'auto',
  width: '80px',
  margin: '0px',
});
export const RescueAvatarPorfilio = styled('img')(({ theme }) => ({
  height: 'auto',
  width: '30px',
  position: 'absolute',
  left: '46px',
  bottom: '-8px',
  [theme.breakpoints.between('sm', 'md')]: {
    width: '28px',
    left: '38px',
    bottom: '-8px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '20px',
    left: '26px',
    bottom: '-8px',
  },
}));

export const RescueAvatarTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.white.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.titleText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '119.49999332427979%',
  textTransform: 'none',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.mediumText.fontSize,
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}));
export const RescueAvatarChips = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '4px 0px 0px 0px',
});

export const RescueQuotasSpan = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.white.main,
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: theme.typography.mediumText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
}));

export const RescueMunt = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
});
export const Tienes = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.white.main,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.mediumText.fontSize,
  letterSpacing: '1.8px',
  textDecoration: 'none',
  textTransform: 'uppercase',
  margin: '0px',
}));

export const TitlePortafolioValue = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));

export const ExpectedReturnValue = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.description.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const CreateDatePorfolio = styled(Typography)(({ theme }) => ({
  textAlign: 'right',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.tertiary.main,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '4px 0px 0px 0px',
}));

/***********Cards Content **********/

export const WithdrawalBodyContainer = styled(Stack)(({ theme }) => ({
  width: '70%',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  alignItems: 'center',
  marginBottom: '25px',
  marginTop: '30px',
  [theme.breakpoints.down('md')]: {
    width: '90%',
  },
}));
export const RescueContentContent = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px',
  boxSizing: 'border-box',
  marginTop: '20px',
  marginBottom: '20px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    minHeight: '350px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
  },
}));
export const RescueContentFunds = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px',
  boxSizing: 'border-box',
  marginTop: '26px',
  marginBottom: '20px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    minHeight: '350px',
    padding: '12px',
    paddingBottom: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
    padding: '12px',
    paddingBottom: '30px',
  },
}));
export const RescueContentPortfolio = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px',
  boxSizing: 'border-box',
  marginTop: '26px',
  marginBottom: '20px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    minHeight: '350px',
    padding: '12px',
    paddingBottom: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
    padding: '12px',
    paddingBottom: '30px',
  },
}));

export const RescueContentFund = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px',
  boxSizing: 'border-box',
  marginTop: '20px',
  marginBottom: '20px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    minHeight: '350px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
  },
}));

export const SelectContent = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
});

export const TitleContainerWithdrawal = styled(Stack)(({ theme }) => ({
  width: '40%',
  justifyContent: 'center',
  height: '100px',
  textAlign: 'center',
  alignItems: 'flex-start',
  marginLeft: '40px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: '0px',
    alignItems: 'center',
    marginTop: '-30px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'center',
    alignItems: 'center',
    marginLeft: '0px',
  },
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  marginLeft: '20px',
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
  },
}));
export const TitleAndAmountContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  marginTop: 0,
  alignItems: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginTop: '-22px',
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: 0,
  },
}));
export const TotalCashContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 16px rgba(61, 64, 75, 0.25)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  isolation: 'isolate',
  width: '100%',
  height: '100px',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  padding: '16px',
  [theme.breakpoints.up('md')]: {
    width: '60%',
    justifyContent: 'space-between',
  },
}));
export const TotalCash = styled(Stack)(({ theme }) => ({
  width: '50%',
  alignItems: 'center',
}));
export const TotalCashTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const AmountStack = styled(Stack)(({ theme }) => ({
  width: '50%',
  alignItems: 'center',
}));

export const AmountTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const TitleSectionRescue = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.museoRegular.fontWeight,
  fontSize: theme.typography.headerText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  alignSelf: 'stretch',
  margin: '0px',
}));
export const SectionSelectRescue = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '16px 0px 0px 0px',
});

export const ButtonContained = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  boxShadow:
    '0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.2)',
  borderRadius: '8px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  height: '60px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  padding: '8px 32px',
  color: theme.palette.white.main,
}));
export const BaseBotton = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '30px 95px',
  boxSizing: 'border-box',
  margin: '0px',
  overflow: 'hidden',
  height: '86px',
  width: '456px',
});

export const MotivacionesGenerarl = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.tertiary.main,
  borderRadius: '14px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2.5px 8px',
  boxSizing: 'border-box',
  height: '22px',
  margin: '0px',
  width: '42px',
}));
export const HmcText = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.littleText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));
//CardsContainerRescue
export const RescueBodyContainer = styled(Stack)(({ theme }) => ({
  width: '70%',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  alignItems: 'center',
  marginTop: '30px',
  marginBottom: '60px',
  [theme.breakpoints.down('md')]: {
    width: '90%',
  },
}));
export const TitleContainerRescue = styled(Stack)(({ theme }) => ({
  width: '40%',
  justifyContent: 'center',
  height: '100px',
  textAlign: 'center',
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: '0px',
    alignItems: 'center',
    marginTop: '-30px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'center',
    alignItems: 'center',
    marginLeft: '0px',
  },
}));
export const AvailableAmountContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  isolation: 'isolate',
  width: '100%',
  height: '100px',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px',
  [theme.breakpoints.up('md')]: {
    width: '80%',
    justifyContent: 'space-between',
  },
}));
export const AvailableAmount = styled(Stack)(({ theme }) => ({
  flex: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
export const AvailableAmountTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.description.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const AmountStackRescue = styled(Stack)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
export const AmountTypographyRescue = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));
export const TitleTextRescue = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
  },
}));
